import { PositionsScreenState } from './reducer'

export const getPositionsScreenRows = (state: { positionsScreen: PositionsScreenState }) =>
  state.positionsScreen.rows

export const getPositionsScreenLoader = (state: { positionsScreen: PositionsScreenState }) =>
  state.positionsScreen.isLoading
